import { FormModel } from '@models/form-model';
import { Query, Mutation } from '../api-hooks/types';
import { environment } from 'environments/environment';

const baseUrl = environment.apiUrl + 'forms/';

export const getForms = (customerId: number): Query<FormModel[]> => ({
  url: `${baseUrl}by_customer/${customerId}/`,
});

export const getForm = (id: number, customerId: number): Query<FormModel> => ({
  url: `${baseUrl}${id}/by_customer/${customerId}/`,
});

export const updateForm = (
  form: FormModel,
  customerId: number
): Mutation<FormModel> => ({
  url: `${baseUrl}${form.id}/by_customer/${customerId}/`,
  method: 'PUT',
  data: { ...form, customer: customerId },
});

export const getPdfUrl = (customerId: number, formId: number) =>
  `${environment.apiUrl}customizations/get_pdf/?customer_id=${customerId}&form_id=${formId}`;
